import { useCallback, useState, useLayoutEffect, useMemo } from "react";
import { Row, Col } from "react-bootstrap"
import FilterReport from "../header/FilterReport"
import styles from "../style.module.css"
import { Tag } from "rsuite"
import { format,startOfMonth, endOfMonth } from "date-fns"
import axiosService from "../../../utils/axios.service";
import _ from "lodash"
import { Column } from '@ant-design/plots';
import { Spin, Tabs } from "antd"
import "../scss/report.scss"
import StorageService from "../../../utils/storage.service";
import ReportKtvTvvDetailCat from "./ReportKtvTvvDetailCat";
import ReportKtvTvvDetailDate from "./ReportKtvTvvDetailDate";
import ReportKtvTvvTargetDetail from "./ReportKtvTvvTargetDetail"
import ReportDoanhSoThuanKtvTvvDetailCat from "./ReportDoanhSoThuanKtvTvvDetailCat"
import { Tooltip } from "antd";

const { TabPane } = Tabs;

const ReportKtvTvvDetail = () => {
    var date = new Date();
    // date.setDate(date.getDate() - 1);
    let month = date.getMonth()
    let year = date.getFullYear()
    if (date.getMonth() == 0) {
        month = 12
        year = year - 1
    }
    let oldMonth = year + '-' + month + '-'
    let day = date.getDate()
    let endOfMonth1 = new Date(endOfMonth(new Date(date)))
    let endOfMonthOld = new Date(endOfMonth(new Date(oldMonth + day)))
    if (day == endOfMonth1.getDate()) {
        day = endOfMonthOld.getDate()
    }

    let olDate = new Date(oldMonth + day)
    const [startDate, setStartDate] = useState(format(new Date(startOfMonth(date)),"yyyy-MM-dd"))
    const [endDate, setEndDate] = useState(format(new Date(date), 'yyyy-MM-dd'))
    const [startOldDate, setStartOldDate] = useState(format(new Date(startOfMonth(olDate)),"yyyy-MM-dd"))
    const [endOldDate, setEndOldDate] = useState(format(new Date(olDate), 'yyyy-MM-dd'))

    const [store, setStore] = useState(
        (JSON.parse(StorageService.getItem("user_info")) && JSON.parse(StorageService.getItem("user_info")).role == 3) ?
            JSON.parse(StorageService.getItem("user_info")).stores[0].id
        : parseInt(StorageService.getItem("currentStore")) )
    const [sortBy, setSortBy] = useState(0)
    const [totalPaid, setTotalPaid] = useState(0)
    const [totalPaidNoTax, setTotalPaidNoTax] = useState(0)
    const [totalOrderNew, setTotalOrderNew] = useState(0)
    const [totalThuan, setTotalThuan] = useState(0)

    const [totalPaidTriet, setTotalPaidTriet] = useState(0)
    const [totalPaidDa, setTotalPaidDa] = useState(0)
    const [totalPaidBody, setTotalPaidBody] = useState(0)
    const [totalPaidMyPham, setTotalPaidMyPham] = useState(0)
    const [totalPaidDauTriet, setTotalDauTriet] = useState(0)
    const [totalPaidGoi, setTotalPaidGoi] = useState(0)
    
    const [ordersByDaysCountBooking, setOrdersByDaysCountBooking] = useState([])
    const [rows, setRows] = useState([])
    const [loading, setLoading] = useState(true);
    const [isExport, setIsExport] = useState(false)
    const [userAdmin, setUserAdmin] = useState(JSON.parse(StorageService.getItem("user_info")))
    const [pageSize, setPageSize] = useState(5)
    const [key, setKey] =  useState([])
    const [userId, setUserId] = useState(userAdmin.id)
    const [userName, setUserName] = useState(userAdmin.name)
    const [target, steTarget] = useState([])
    const [targetDetail, setTargetDetail] = useState([])
    const [keyOb, setKeyOb] = useState({})
    const [selectUser, setSelectUser] = useState('')

    const [totalThuanOb, setTotalThuanOb] = useState({
        triet_thuan: 0,
        da_thuan: 0,
        body_thuan: 0,
        my_pham_thuan: 0,
        dau_triet_thuan: 0,
        goi_thuan: 0,

    })

    const [tableThuan, setTableThuan] = useState([])
    
    const [totalPaidTarget, setTotalPaidTarget] = useState({
        totalPaidUpPremium: 0,
        totalPaidPremium08: 0, 
        totalPaidPremiumFullbody: 0,
        totalPaidDauTriet: 0,
        totalPaidCentUpgrade: 0,
        totalPaidTheoVung: 0,
        totalPaidBody: 0,
        totalPaidDa: 0
    })
    const handleRangeDate = useCallback((sDate, eDate) => {
        setStartDate(sDate)
        setEndDate(eDate)
        handleOleDate(sDate, eDate)
    }, [startDate, endDate])

    const handleStore = useCallback((e) => {
        setStore(e)
    }, [store])
    
    const handleRangeDateOld = useCallback((sDate, eDate) => {
        setStartOldDate(sDate)
        setEndOldDate(eDate)
       
    }, [startOldDate, endOldDate])

    const handleOleDate = async (start, end) => {
        start = new Date(start)
        end = new Date(end)
        let oldMonth = start.getFullYear() + '-' + start.getMonth() + '-'
        let olDate = format(new Date(startOfMonth(new Date(oldMonth + start.getDate()))), 'yyyy-MM-dd' )
        let olEndDate = format(new Date(new Date(oldMonth + end.getDate())), 'yyyy-MM-dd' )
        setStartOldDate(olDate)
        setEndOldDate(olEndDate)
    }

    const handleSortBy = useCallback((e) => {
        setSortBy(e)
    }, [sortBy]);

    useLayoutEffect(() => {
        setLoading(true)
        fetchData(store, endDate, startDate, sortBy, startOldDate, endOldDate)
    }, [store, endDate, startDate, sortBy, startOldDate, endOldDate, selectUser])
    
    const fetchData = async (s, eD, sD, sBy, startOldDate, endOldDate) => {
        const rs = await axiosService(`api/reports/store/work/ktv-details/${s}?storeId=${s}&startDate=${sD}&endDate=${eD}&startOldDate=${startOldDate}&endOldDate=${endOldDate}&sortBy=${sBy}&selectUser=${selectUser}`, "GET")
        const { data } = rs.data
        if (rs.status == 200) {
            setRows(data.dataTable)

            setTotalPaid(data.totalPaid)
            setTotalPaidNoTax(data.totalPaidNoTax)
            setTotalOrderNew(data.totalOrderNew)
            setTotalThuan(data.total_thuan)

            setTotalPaidTriet(data.totalPaidTriet)
            setTotalPaidDa(data.totalPaidDa)
            setTotalPaidBody(data.totalPaidBody)
            setTotalPaidMyPham(data.totalPaidMyPham)
            setTotalPaidGoi(data.totalPaidGoi)

            setTotalThuanOb(data.totalThuanOb)
            setTableThuan(data.tableThuan)

            // setKey(data.key)
            // steTarget(data.target)
            // setTargetDetail([...data.targetDetail])
            // setTotalPaidTarget(data.totalTagetOf)
            // setKeyOb({...data.keyOb})

            let rowsCountBooking = []
            let rowsCountBookingSuccess = []
            let rowsCountBookingService = {}
            let rowsCountService = []
            for (let item of data.dataTable) {
                let rowCountBooking = {
                    date: item.users_name,
                    value: Number(item.comparePaid),
                    type: 'Tiền thực thu'
                }
                let rowCountBookingSuccess = {
                    date: item.users_name,
                    value: Number(item.compareOrderTv),
                    type: 'Đơn hàng mới'
                }
                if (rowsCountBookingService[item.users_name] == undefined) {
                    rowsCountBookingService[item.users_name] = {
                        date: item.users_name,
                        value: Number(item.compareAov),
                        type: 'AOV'
                    }
                } else {
                    rowsCountBookingService[item.users_name]['value'] +=  Number(item.compareAov)
                    rowsCountBookingService[item.users_name]['value'] = Number(Number(rowsCountBookingService[item.users_name]['value']).toFixed(1))
                }
                let rowCountService = {
                    date: item.users_name,
                    value: Number(item.compareService),
                    type: 'Dịch vụ phục vụ'
                }
                rowsCountBooking.push(rowCountBooking)
                rowsCountBookingSuccess.push(rowCountBookingSuccess)
                rowsCountService.push(rowCountService)
            }
            let rowsCountBookingServiceArr = []
            for (let item of Object.values(rowsCountBookingService)) {
                rowsCountBookingServiceArr.push(item)
            }
            setOrdersByDaysCountBooking([...rowsCountBooking, ...rowsCountBookingSuccess, ...rowsCountBookingServiceArr])
            let value = "yyyy-MM-dd"
                if (sortBy === 1) {
                    value = "ww"
                } else if (sortBy === 2) {
                    value = "MM"
                }
            setLoading(false)
        }
    }
    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };

    const config = useMemo(() => configChart(ordersByDaysCountBooking, convertCurrency), [ordersByDaysCountBooking])
    
    const handleExportData = () => {
        setIsExport(true)
        setTimeout(() => {
            setIsExport(false)
        }, 2000)
    }
    const  handleChange = (e) => {
        setPageSize(e.pageSize)
    }

    const selectListUser = (e) => {
        let list = e ?? ""
        setSelectUser(list.toString());
    };
    return (
        <div className={`${styles.background} container-fluid report-page`}>
            <FilterReport startDate={startDate} endDate={endDate}
                handleRangeDate={handleRangeDate} store={store}
                handleStore={handleStore}
                sortBy={sortBy} handleSortBy={handleSortBy}
                title={"Bảng chi tiết từng KTV"} type={"ktv-tvv-detail"}
                csvData={rows} isExport={isExport}
                handleExportData={handleExportData}
                header={
                    [
                        { label: 'Thời gian', key: "date" },
                        { label: "Số lượng lịch đặt", key: "count_booking" },
                        { label: "Số lượng lịch huỷ", key: "count_close" },
                        { label: "Số lượng lịch thành công", key: "count_success" },
                        { label: "Tỉ lệ huỷ/tổng lịch đặt", key: "proportion" },
                        { label: "Số lượng khách hàng phục vụ", key: "count_customer" },
                        { label: "Lượt dịch vụ", key: "count_service" },
                    ]
                }
                userAdmin={userAdmin}
                startOldDate={startOldDate} endOldDate={endOldDate}
                handleRangeDateOld={handleRangeDateOld}
                selectListUser = {selectListUser}
            />
            <Spin spinning={loading}>
                <div className="h-100">
                    <Row className="mt-2">
                        <Col xs={12} md={6} lg={3} className="mb-2">
                            <Tag color="blue" className="w-100 p-2 h-100">
                                <div className={styles.textTag3}>
                                    <Tooltip title='Tổng tiền đã trừ VAT của tất cả kỹ thuật viên nhận được khi khách hàng thanh toán hoá đơn kỹ thuật viên đã tư vấn bằng các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, sử dụng tiền trong tài khoản, không bao gồm sử dụng điểm tích lũy.'>
                                        Tổng thực thu bán hàng <i className="fas fa-info-circle"></i>
                                    </Tooltip>
                                </div>
                                <div className="d-flex justify-content-end mb-2">
                                    <div className={`${styles.textTag} ml-3`}>
                                        {convertCurrency(totalPaid || 0)}
                                    </div>
                                </div>
                                <div className={styles.textTag3}>
                                    <Tooltip title='Số tiền cần thu sau khi đã trừ các khoản giảm trừ bao gồm: giảm giá, chiết khấu, thuế (nếu có). (Doanh số thuần = Doanh số - Giảm giá). Chỉ bao gồm những hoá đơn kỹ thuật viên tư vấn.'>
                                        Tổng doanh số thuần <i className="fas fa-info-circle"></i>
                                    </Tooltip>
                                </div>
                                <div className="d-flex justify-content-end mb-2">
                                    <div className={`${styles.textTag} ml-3`}>
                                        {convertCurrency(totalThuan || 0)}
                                    </div>
                                </div>
                                <div className={styles.textTag3}>
                                    <Tooltip title='Tổng số lượng hóa đơn hoàn thành ngày hôm đó (bao gồm đơn có tiền, nâng cấp, nạp thẻ tiền, không bao gồm các hóa đơn hủy, chuyển đổi).'>
                                        Số đơn hàng  <i className="fas fa-info-circle"></i>
                                    </Tooltip>
                                </div>
                                <div className="d-flex justify-content-end">
                                    <div className={`${styles.textTag} ml-3`}>{totalOrderNew || 0}</div>
                                </div>
                            </Tag>
                        </Col>
                        <Col xs={12} md={6} lg={3} className="mb-2">
                            <Tag color="green" className=" w-100 h-100 p-2">
                                <p className={styles.textTag3}>THỰC THU BÁN HÀNG NHÓM DỊCH VỤ</p>
                                <div className="d-flex justify-content-between p-2">
                                    <div>
                                        <p className={styles.textTag4}>Triệt lông:</p> 
                                        <p className={styles.textTag4}>Da: </p> 
                                        <p className={styles.textTag4}>Chăm sóc body:</p>
                                        <p className={styles.textTag4}>Mỹ phẩm:</p>
                                        <p className={styles.textTag4}>Đầu triệt:</p>
                                        <p className={styles.textTag4}>Gội đầu:</p>
                                    </div>
                                    <div>
                                        <p className={styles.textTag3}>{convertCurrency(totalPaidTriet)}</p>
                                        <p className={styles.textTag3}>{convertCurrency(totalPaidDa)}</p>
                                        <p className={styles.textTag3}>{convertCurrency(totalPaidBody)}</p>
                                        <p className={styles.textTag3}>{convertCurrency(totalPaidMyPham)}</p>
                                        <p className={styles.textTag3}>{convertCurrency(totalPaidDauTriet)}</p>
                                        <p className={styles.textTag3}>{convertCurrency(totalPaidGoi)}</p>
                                    </div>
                                </div>
                            </Tag>
                        </Col>
                        <Col xs={12} md={6} lg={3} className="mb-2">
                            <Tag color="violet" className=" w-100 h-100 p-2">
                                <p className={styles.textTag3}>DOANH SỐ THUẦN NHÓM DỊCH VỤ</p>
                                <div className="d-flex justify-content-between p-2">
                                    <div>
                                        <p className={styles.textTag4}>Triệt lông:</p> 
                                        <p className={styles.textTag4}>Da: </p> 
                                        <p className={styles.textTag4}>Chăm sóc body:</p>
                                        <p className={styles.textTag4}>Mỹ phẩm:</p>
                                        <p className={styles.textTag4}>Đầu triệt:</p>
                                        <p className={styles.textTag4}>Gội đầu:</p>
                                    </div>
                                    <div>
                                        <p className={styles.textTag3}>{convertCurrency(totalThuanOb.triet_thuan)}</p>
                                        <p className={styles.textTag3}>{convertCurrency(totalThuanOb.da_thuan)}</p>
                                        <p className={styles.textTag3}>{convertCurrency(totalThuanOb.body_thuan)}</p>
                                        <p className={styles.textTag3}>{convertCurrency(totalThuanOb.my_pham_thuan)}</p>
                                        <p className={styles.textTag3}>{convertCurrency(totalThuanOb.dau_triet_thuan)}</p>
                                        <p className={styles.textTag3}>{convertCurrency(totalThuanOb.goi_thuan)}</p>
                                    </div>
                                </div>
                            </Tag>
                        </Col>
                        {/* <Col xs={12} md={6} lg={2} className="mb-2">
                            <Tag className="w-100 h-100 p-2" style={{background: '#fb8a25'}}>
                                <p className={styles.textTag3}>
                                <Tooltip title='Tổng tiền thu về từ giao dịch thanh toán tiền của khách hàng khi mua dịch vụ. Chỉ bao gồm các hoá đơn kỹ thuật viên tư vấn '>
                                KẾT QUẢ MỤC TIÊU  <i className="fas fa-info-circle"></i>
                            </Tooltip></p>
                                <div className="d-flex justify-content-between p-2">
                                    <div>
                                        <p className={styles.textTag4}>Nâng cấp Triệt lông Premium</p> 
                                        <p className={styles.textTag4}>Triệt lông Premium 08 vùng</p> 
                                        <p className={styles.textTag4}>Triệt lông Premium Fullbody</p>
                                        <p className={styles.textTag4}>Đầu triệt cá nhân</p>
                                    </div>
                                    <div>
                                        <p className={styles.textTag3}>{convertCurrency(totalPaidTarget.totalPaidUpPremium)}</p>
                                        <p className={styles.textTag3}>{convertCurrency(totalPaidTarget.totalPaidPremium08)}</p>
                                        <p className={styles.textTag3}>{convertCurrency(totalPaidTarget.totalPaidPremiumFullbody)}</p>
                                        <p className={styles.textTag3}>{convertCurrency(totalPaidTarget.totalPaidDauTriet)}</p>
                                    </div>
                                </div>
                            </Tag>
                        </Col>
                        <Col xs={12} md={6} lg={2} className="mb-2" >
                            <Tag className=" w-100 h-100 p-2" style={{background: '#fb8a25'}}>
                                <p className={styles.textTag3}>KẾT QUẢ MỤC TIÊU</p>
                                <div className="d-flex justify-content-between p-2">
                                    <div>
                                        <p className={styles.textTag4}>Cent Upgrade</p> 
                                        <p className={styles.textTag4}>Triệt lông theo vùng</p> 
                                        <p className={styles.textTag4}>Chăm sóc body</p>
                                        <p className={styles.textTag4}>Chăm sóc Da</p>
                                    </div>
                                    <div>
                                        <p className={styles.textTag3}>{convertCurrency(totalPaidTarget.totalPaidCentUpgrade)}</p>
                                        <p className={styles.textTag3}>{convertCurrency(totalPaidTarget.totalPaidTheoVung)}</p>
                                        <p className={styles.textTag3}>{convertCurrency(totalPaidTarget.totalPaidBody)}</p>
                                        <p className={styles.textTag3}>{convertCurrency(totalPaidTarget.totalPaidDa)}</p>
                                    </div>
                                </div>
                            </Tag>
                        </Col> */}
                    </Row>
                </div>

                <Row className="mt-2" style={{alignItems: 'end'}}>
                    <Col xs={12} md={12}>
                        <div style={{ backgroundColor: "white" }} >
                            <div style={{ }} className="p-2">
                                <Tabs defaultActiveKey="1">
                                    <TabPane tab="Thực thu nhóm dịch vụ" key="1">
                                        <ReportKtvTvvDetailCat
                                            table = {rows}
                                            startDate={startDate}
                                            endDate={endDate}
                                            userId={userId}
                                            userName={userName}
                                        />
                                    </TabPane>
                                    <TabPane tab="Doanh số thuần nhóm dịch vụ" key="2">
                                        <ReportDoanhSoThuanKtvTvvDetailCat
                                            table = {tableThuan}
                                            startDate={startDate}
                                            endDate={endDate}
                                            userId={userId}
                                            userName={userName}
                                        />
                                    </TabPane>
                                    {/* <TabPane tab="Mục tiêu theo tuần" key="3">
                                        <ReportKtvTvvDetailDate
                                            table = {target}
                                            startDate={startDate}
                                            endDate={endDate}
                                            userId={userId}
                                            userName={userName}
                                            keyTable={key}
                                            keyOb={keyOb}
                                        />
                                    </TabPane>
                                    <TabPane tab="Chi tiết KTV" key="4">
                                        <ReportKtvTvvTargetDetail
                                            table = {targetDetail}
                                            startDate={startDate}
                                            endDate={endDate}
                                            userId={userId}
                                            userName={userName}
                                            keyTable={key}
                                        />
                                    </TabPane> */}
                                </Tabs>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row className="mt-2" style={{alignItems: 'end'}}>
                    <Col xs={12} md={12} className="hide-mobile">
                        <div style={{ backgroundColor: "white" }} className="p-2">
                            <Column {...config} />
                        </div>
                    </Col>
                </Row>
            </Spin>
        </div >

    )
}

const configChart = (data, convertCurrency) => {  
    var config = {
        data: data,
        xField: "date",
        yField: "value",
        seriesField: "type",
        height: 700,
        onResize: true,
        isStack: true,
        colorField: 'type', // or seriesField in some cases
        xAxis: {
            title: {
              text: "KTV",
              position: "end",
              offset: 0,
              spacing: 8,
              style: {
                fontSize: 13,
                fontWeight: 900,
                textAlign: "start"
              }
            },
            line: {
              style: {
                stroke: "black"
              }
            },
            tickLine: {
              style: {
                stroke: "black"
              }
            },
            label: {
              autoRotate: true,
              style: {
                fill: "black",
              //   fontSize: 10
              },
            }
          },
        yAxis: {
            line: {
              style: {
                lineWidth: 2
              }
            },
            label: {
              style: {
                fill: "black"
              },
              offset: 15,
              formatter: (text) => _.round(_.divide(text, 1), 2).toLocaleString()
            }
        },
        color: ["#673ab7", "#2196f3", "#4caf50"],
        label: {
            position: 'middle', // 'top', 'bottom', 'middle'
            formatter: (text) => {
                return text.value + '%';
            },
            style: {
                fontWeight: 600
            }
          
        },
        interactions: [
            {
                type: 'active-region',
                enable: false
            }
        ],
        connectedArea: {
            style: (oldStyle) => {
                return {
                    fill: 'rgba(0,0,0,0.2)',
                    stroke: oldStyle.fill,
                    lineWidth: 1
                };
            }
        },
        legend: {
            position: "right",
            marker: {
              symbol: "square"
            },
            itemName: {
              formatter: (text, item, index) => {
                return '';
              }
            }
        },
        tooltip: {
            customContent: (count, data) => {
                let fileHtml = ''
                let title = ''
                for(let item of data) {
                    title = item.title
                    let name = item.name
                    let value = Number(item.value)
                    fileHtml += '<li class="g2-tooltip-list-item">'
                    fileHtml += '<span class="g2-tooltip-marker" style="background: '+item.color+'; width: 8px; height: 8px; border-radius: 50%; display: inline-block; margin-right: 8px;">' + '</span>'
                    fileHtml += '<span class="g2-tooltip-name" style="color: '+item.color+';">'+item.name + '</span>'
                    fileHtml += '<span class="g2-tooltip-value" style="color: '+item.color+';">'+ value + ' %</span>'
                    fileHtml += '</li>'
                }
                return `<div class="g2-tooltip-title" style="margin-bottom: 12px; margin-top: 12px; padding-top: 12px; font-weight: bold; font-size: 15px"><p> ${title} </div>
                    <ul class="g2-tooltip-list" style="margin: 0px; list-style-type: none; padding: 12px !important; ">
                        ${fileHtml}
                        </br>
                    </ul>
                </div>`;
            }
        },
      };
    return config
}
export default ReportKtvTvvDetail